export const TRANSLATIONS_DE = {
  app_name: "GRS Portal",
  maintainance: {
    title: "Wartungsarbeiten",
  },
  dashboard: {
    title: "Mein Start",
    platform: {
      pom: "Inverkehrbringung von Batterien",
      batteryPickup: "Batterieabholung",
      shortcuts: {
        pom: {
          new_reporting: "Meldungen",
          group_overview: "Meine Kontoverwaltung",
          manufactorer_overview: "Herstellerverzeichnis",
        },
      },
    },
  },
  general: {
    new: "Neu",
    scrollToTop: "Nach oben scrollen",
    error_occurred:
      'Es ist leider ein Fehler aufgetreten - Bitte senden Sie die Fehlermeldung an portal@grs-batterien.de - [{{errorCode}}: "{{errorMsg}}"]',
    contact_grs: "Kontakt GRS",
    logout: "Ausloggen",
    support: "Support",
    close: "Schließen",
    search: "Suche",
    email: {
      text: "E-Mail",
    },
    cancel: {
      text: "Abbrechen",
    },
    continue: {
      text: "Weiter",
    },
    form: {
      required_field_warning: {
        text: "Erforderlich",
      },
    },
    active: "Aktiv",
    inactive: "Inaktiv",
    login_button: {
      text: "Anmelden",
    },
    forgot_password_link: {
      text: "Passwort vergessen?",
    },
    login_title: {
      text: "Anmeldung GRS Portal",
    },
    password: {
      text: "Passwort",
    },
    sign_in_to_account: {
      text: "Anmeldung zum Konto",
    },
    unsavedData: "Es gibt nicht gespeicherte Änderungen. Sind Sie sicher, dass Sie die Seite verlassen wollen?",
    warning: "Achtung!",
    leave: "Verlassen",
  },
  table: {
    deleteTooltip: "Eintrag entfernen",
    editTooltip: "Eintrag bearbeiten",
    nRowsSelected: "{{0}} Zeile(n) ausgewählt",
    editRow: {
      cancelTooltip: "Abbrechen",
      saveTooltip: "Speichern",
      deleteText: "Möchtest du diesen Eintrag entfernen?",
    },
    toolbar: {
      searchTooltip: "Suche",
      searchPlaceholder: "Suche...",
    },
    body: {
      emptyDataSourceMessage: "Keine Daten vorhanden",
    },
    labelDisplayedRows: "{{from}}-{{to}} von {{count}}",
    labelDisplayedRowsCustomTable: "{from}-{to} von {count}",
    labelRowsSelect: "Einträge",
    labelRowsPerPage: "Einträge pro Seite:",
    firstTooltip: "Erste Seite",
    previousTooltip: "Vorherige Seite",
    nextTooltip: "Nächste Seite",
    lastTooltip: "Letzte Seite",
  },
  navigation: {
    basedata: {
      label: "Stammdaten",
      bcEdit: "Stammdaten bearbeiten",
      users: {
        label: "Benutzerübersicht",
      },
      groups: {
        label: "Gruppenübersicht",
        account: "Meine Kontoverwaltung",
      },
    },
  },
  basedata: {
    users: {
      heading: "Benutzer",
      table: {
        type: "Typ",
        role: "Rolle",
        erp_number: "ERP-Nummer",
        groupName: "Firma",
        name: "Name",
        email: "E-Mail",
        login: "Login",
        hasLogin: "Portal-Login vorhanden",
        group: {
          admin: "Admin",
          customer: "Kunde",
          pom: "POM",
          pom_agency: "POM Agentur",
          pom_agency_member: "POM Agenturmitglied",
          pom_representative: "POM Bevollmächtigter",
        },
        filter: {
          status: {
            text: "Status",
            active: "Aktiv",
            inactive: "Inaktiv",
          },
        },
        action: {
          detail: "Detailansicht öffnen",
          logout: "Anmeldung als Super Admin",
        },
        search: {
          email: "E-Mail",
          lastName: "Nachname",
        },
      },
      login: {
        text: "Möchten Sie sich als Benutzer {{firstName}} {{lastName}} anmelden?",
        button: "login als {{firstName}} {{lastName}}",
        header: "Als Benutzer anmelden",
        successLogin: "Erfolgreich als Benutzer angemeldet",
        successLogout: "Erfolgreich als Benutzer abgemeldet",
        errorLogin: "Login als Benutzer {{email}} fehlgeschlagen: {{message}}",
        noLogin: "Für diesen Benutzer wurden noch keine Zugangsdaten ins Portal übertragen.",
      },
      logout: {
        header: "Als Benutzer abmelden",
        text: "Möchten Sie sich als Admin anmelden?",
        agency_text: "Möchten Sie sich als Agentur anmelden?",
        agency_action: "Anmeldung als Agentur",
        unsaved_data_warning: "Es gibt nicht gespeicherte Änderungen. Wenn Sie sich abmelden, gehen diese verloren.",
      },
      edit: {
        title: "Anrede",
        jobtitle: "Berufsbezeichnung",
        firstName: "Vorname",
        lastName: "Nachname",
        externalId: "Externe ID",
        pom_type: "Benutzertyp POM",
        loginEmail: "E-Mail (login)",
        deliveryEmail: "E-Mail (Benachrichtigungen)",
        phone: "Telefonnummer",
        pom_role: {
          announcer: "POM Melder",
          main_contact: "POM Hauptansprechpartner",
        },
      },
      detail: "Benutzer-Details",
    },
    addresses: {
      type: {
        invoice: "Rechnungsadresse",
      },
    },
    groups: {
      groupContracts: {
        contractDetails: "Vereinbarung Details",
        startDate: "Startdatum",
        startDateCurrentBillingType: "Startdatum aktuelle Abrechnungsart",
        endDate: "Enddatum",
        takeBackSystem: "Rücknahmesystem",
      },
      contractsTable: {
        type: "Typ",
        pomType: "POM",
        contract_number: "Vereinbarungsnummer",
        contracts: "Vereinbarungen",
      },
      edit: {
        isPomAgencyAnnouncer: "i.S.d. BattG",
        erpNumber: "ERP-Nummer",
        address: "Adresse",
        tradeRegisterNumber: "Handelsregister-Nummer",
        vatId: "Umsatzsteuer-ID",
        agencyGroup: "Agentur",
      },
      detail: {
        text: "Gruppe Details, ERP-Nummer - {{erpNumber}}",
        bcEditButton: "Stammdaten bearbeiten",
      },
      heading: "Gruppen",
      table: {
        erpNr: "ERP-Nummer",
        name: "Name",
        type: "Typ",
        empty: "Keine Gruppen gefunden. Angezeigt werden nur Gruppen mit POM-Vertrag sowie Agenturen, Agenturmitglieder und Bevollmächtigte.",
        search: {
          agencyName: "Name",
          erp: "ERP-Nummer",
          name: "Name",
        },
      },
      pom_announcement_period: "Meldungszeitraum",
    },
    general: {
      yes: {
        text: "Ja",
      },
      no: {
        text: "Nein",
      },
    },
    group: {
      groupType: "Gruppentyp",
      agency_title: "Agentur",
      pom_heading: "POM",
      users_empty: "Diese Gruppe hat keine Benutzer mit POM-Zugang.",
    },
  },
  country: {
    ad: "Andorra",
    ae: "Vereinigte Arabische Emirate",
    af: "Afghanistan",
    ag: "Antigua und Barbuda",
    ai: "Anguilla",
    al: "Albanien",
    am: "Armenien",
    an: "Niederländische Antillen",
    ao: "Angola",
    aq: "Antarktis",
    ar: "Argentinien",
    as: "Amerikanisch-Samoa",
    at: "Österreich",
    au: "Australien",
    aw: "Aruba",
    ax: "Åland",
    az: "Aserbaidschan",
    ba: "Bosnien und Herzegowina",
    bb: "Barbados",
    bd: "Bangladesch",
    be: "Belgien",
    bf: "Burkina Faso",
    bg: "Bulgarien",
    bh: "Bahrain",
    bi: "Burundi",
    bj: "Benin",
    bm: "Bermuda",
    bn: "Brunei Darussalam",
    bo: "Bolivien",
    br: "Brasilien",
    bs: "Bahamas",
    bt: "Bhutan",
    bv: "Bouvetinsel",
    bw: "Botswana",
    by: "Belarus (Weißrussland)",
    bz: "Belize",
    ca: "Kanada",
    cc: "Kokosinseln (Keelinginseln)",
    cd: "Kongo",
    cf: "Zentralafrikanische Republik",
    cg: "Republik Kongo",
    ch: "Schweiz",
    ci: "Elfenbeinküste",
    ck: "Cookinseln",
    cl: "Chile",
    cm: "Kamerun",
    cn: "China, Volksrepublik",
    co: "Kolumbien",
    cr: "Costa Rica",
    cu: "Kuba",
    cv: "Kap Verde",
    cx: "Weihnachtsinsel",
    cy: "Zypern",
    cz: "Tschechische Republik",
    de: "Deutschland",
    dj: "Dschibuti",
    dk: "Dänemark",
    dm: "Dominica",
    do: "Dominikanische Republik",
    dz: "Algerien",
    ec: "Ecuador",
    ee: "Estland (Reval)",
    eg: "Ägypten",
    eh: "Westsahara",
    er: "Eritrea",
    es: "Spanien",
    et: "Äthiopien",
    fi: "Finnland",
    fj: "Fidschi",
    fk: "Falklandinseln (Malwinen)",
    fm: "Mikronesien",
    fo: "Färöer",
    fr: "Frankreich",
    ga: "Gabun",
    gb: "Großbritannien und Nordirland",
    gd: "Grenada",
    ge: "Georgien",
    gf: "Französisch-Guayana",
    gg: "Guernsey (Kanalinsel)",
    gh: "Ghana",
    gi: "Gibraltar",
    gl: "Grönland",
    gm: "Gambia",
    gn: "Guinea",
    gp: "Guadeloupe",
    gq: "Äquatorialguinea",
    gr: "Griechenland",
    gs: "Südgeorgien und die Südl. Sandwichinseln",
    gt: "Guatemala",
    gu: "Guam",
    gw: "Guinea-Bissau",
    gy: "Guyana",
    hk: "Hongkong",
    hm: "Heard- und McDonald-Inseln",
    hn: "Honduras",
    hr: "Kroatien",
    ht: "Haiti",
    hu: "Ungarn",
    id: "Indonesien",
    ie: "Irland",
    il: "Israel",
    im: "Insel Man",
    in: "Indien",
    xk: "Kosovo",
    io: "Britisches Territorium im Indischen Ozean",
    iq: "Irak",
    ir: "Iran",
    is: "Island",
    it: "Italien",
    je: "Jersey (Kanalinsel)",
    jm: "Jamaika",
    jo: "Jordanien",
    jp: "Japan",
    ke: "Kenia",
    kg: "Kirgisistan",
    kh: "Kambodscha",
    ki: "Kiribati",
    km: "Komoren",
    kn: "St. Kitts und Nevis",
    kp: "Nordkorea",
    kr: "Südkorea",
    kw: "Kuwait",
    ky: "Kaimaninseln",
    kz: "Kasachstan",
    la: "Laos",
    lb: "Libanon",
    lc: "St. Lucia",
    li: "Liechtenstein",
    lk: "Sri Lanka",
    lr: "Liberia",
    ls: "Lesotho",
    lt: "Litauen",
    lu: "Luxemburg",
    lv: "Lettland",
    ly: "Libyen",
    ma: "Marokko",
    mc: "Monaco",
    md: "Moldawien",
    mg: "Madagaskar",
    mh: "Marshallinseln",
    mk: "Mazedonien",
    ml: "Mali",
    mm: "Myanmar (Burma)",
    mn: "Mongolei",
    mo: "Macau",
    mp: "Nördliche Marianen",
    mq: "Martinique",
    mr: "Mauretanien",
    ms: "Montserrat",
    mt: "Malta",
    mu: "Mauritius",
    mv: "Malediven",
    mw: "Malawi",
    mx: "Mexiko",
    my: "Malaysia",
    mz: "Mosambik",
    na: "Namibia",
    nc: "Neukaledonien",
    ne: "Niger",
    nf: "Norfolkinsel",
    ng: "Nigeria",
    ni: "Nicaragua",
    nl: "Niederlande",
    no: "Norwegen",
    np: "Nepal",
    nr: "Nauru",
    nu: "Niue",
    nz: "Neuseeland",
    om: "Oman",
    pa: "Panama",
    pe: "Peru",
    pf: "Französisch-Polynesien",
    pg: "Papua-Neuguinea",
    ph: "Philippinen",
    pk: "Pakistan",
    pl: "Polen",
    pm: "St. Pierre und Miquelon",
    pn: "Pitcairninseln",
    pr: "Puerto Rico",
    ps: "Palästina",
    pt: "Portugal",
    pw: "Palau",
    py: "Paraguay",
    qa: "Katar",
    re: "Réunion",
    ro: "Rumänien",
    rw: "Ruanda",
    sa: "Saudi-Arabien",
    sb: "Salomonen",
    sc: "Seychellen",
    sd: "Sudan",
    se: "Schweden",
    sg: "Singapur",
    sh: "St. Helena",
    si: "Slowenien",
    sj: "Svalbard und Jan Mayen",
    sk: "Slowakei",
    sl: "Sierra Leone",
    sm: "San Marino",
    sn: "Senegal",
    so: "Somalia",
    sr: "Suriname",
    st: "São Tomé und Príncipe",
    sv: "El Salvador",
    sy: "Syrien",
    sz: "Swasiland",
    tc: "Turks- und Caicosinseln",
    td: "Tschad",
    tf: "Französische Süd- und Antarktisgebiete",
    tg: "Togo",
    th: "Thailand",
    tj: "Tadschikistan",
    tk: "Tokelau",
    tl: "Timor-Leste",
    tm: "Turkmenistan",
    tn: "Tunesien",
    to: "Tonga",
    tr: "Türkei",
    tt: "Trinidad und Tobago",
    tv: "Tuvalu",
    tw: "Taiwan",
    tz: "Tansania",
    ua: "Ukraine",
    ug: "Uganda",
    um: "Amerikanisch-Ozeanien",
    us: "Vereinigte Staaten von Amerika",
    uy: "Uruguay",
    uz: "Usbekistan",
    va: "Vatikanstadt",
    vc: "St. Vincent und die Grenadinen",
    ve: "Venezuela",
    vg: "Britische Jungferninseln",
    vi: "Amerikanische Jungferninseln",
    vn: "Vietnam",
    vu: "Vanuatu",
    wf: "Wallis und Futuna",
    ws: "Samoa",
    ye: "Jemen",
    yt: "Mayotte",
    za: "Südafrika",
    zm: "Sambia",
    zw: "Simbabwe",
    rs: "Serbien",
    me: "Montenegro",
    bl: "Saint-Barthélemy",
    bq: "Bonaire, Sint Eustatius und Saba",
    cw: "Curaçao",
    mf: "Saint-Martin (franz. Teil)",
    sx: "Sint Maarten (niederl. Teil)",
    ss: "Südsudan",
  },
  clear_all_filters: "Alle Filter entfernen",
  contact: {
    title: "Hilfe und Kontakt",
    text: {
      body: "Für Rückfragen aller Art kontaktieren Sie uns bitte unter {{mail}} und geben Sie relevante Informationen (z.B. Auftragsnummer, Melde-ID, …) an.",
      greeting: "Sehr geehrte Damen und Herren,",
      mail: "portal@grs-batterien.de",
      parting: "Wir freuen uns Ihnen helfen zu können.",
      team: "Ihr GRS-Team",
    },
  },
  dataPrivacy: {
    title: "Datenschutzerklärung",
    link: "Datenschutz",
    text: {
      firstParagraph_subheading: "Datensicherheit",
      dataSecurity_subheading: "Datensicherheit",
      ipaddress_subheading: "Speicherung der IP-Adresse",
      storagePeriod_subheading: "Speicherdauer",
      affectedPerson_subheading: "Ihre Rechte als betroffene Person",
      article15_subheading: "Auskunftsrecht (Art. 15 DSGVO)",
      article16_subheading: "Recht auf Berichtigung (Art. 16 DSGVO)",
      article17_subheading: "Recht auf Löschung (Art. 17 DSGVO)",
      article18_subheading: "Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)",
      article20_subheading: "Recht auf Datenübertragbarkeit (Art. 20 DSGVO)",
      article7_subheading: "Widerrufsrecht (Art. 7 DSGVO)",
      article21_subheading: "Widerspruchsrecht (Art. 21 DSGVO)",
      article77_subheading: "Beschwerderecht bei einer Aufsichtsbehörde (Art. 77 DSGVO)",
      enforcement_subheading: "Geltendmachung Ihrer Rechte",
      firstParagraph:
        "Wir freuen uns über Ihren Besuch auf unserer Webseite. Nachfolgend möchten wir Sie über den Umgang mit Ihren Daten gem. Art. 13 Datenschutzgrundverordnung (DSGVO) informieren.",
      dataSecurity:
        "Um Ihre Daten vor unerwünschten Zugriffen möglichst umfassend zu schützen, treffen wir technische und organisatorische Maßnahmen. Wir setzen auf unseren Webseiten ein Verschlüsselungsverfahren ein. Ihre Angaben werden von Ihrem Rechner zu unserem Server und umgekehrt über das Internet mittels einer TLS-Verschlüsselung übertragen. Sie erkennen dies in der Regel daran, dass in der Statusleiste Ihres Browsers das Schloss-Symbol geschlossen ist und die Adresszeile mit https:// beginnt.",
      ipaddress: "Darüber hinaus speichern wir keine IP-Adressen.",
      storagePeriod:
        " Sofern wir nicht im Einzelnen bereits über die Speicherdauer informiert haben, löschen wir personenbezogene Daten, wenn sie für die vorgenannten Verarbeitungszwecke nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten einer Löschung entgegenstehen.",
      affectedPerson:
        "Bei der Verarbeitung Ihrer personenbezogenen Daten gewährt die DSGVO Ihnen als betroffene Person bestimmte Rechte: Ihre Rechte als betroffene Person",
      article15:
        "Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob Sie betreffende personenbezogene Daten verarbeitet werden; ist dies der Fall, so haben Sie ein Recht auf Auskunft über diese personenbezogenen Daten und auf die in Art. 15 DSGVO im Einzelnen aufgeführten Informationen.",
      article16:
        "Sie haben das Recht, unverzüglich die Berichtigung Sie betreffender unrichtiger personenbezogener Daten und ggf. die Vervollständigung unvollständiger Daten zu verlangen.",
      article17:
        "Sie haben das Recht, zu verlangen, dass Sie betreffende personenbezogene Daten unverzüglich gelöscht werden, sofern einer der in Art. 17 DSGVO im Einzelnen aufgeführten Gründe zutrifft.",
      article18:
        "Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen, wenn eine der in Art. 18 DSGVO aufgeführten Voraussetzungen gegeben ist, z. B. wenn Sie Widerspruch gegen die Verarbeitung eingelegt haben, für die Dauer der Prüfung durch den Verantwortlichen.",
      article20:
        "In bestimmten Fällen, die in Art. 20 DSGVO im Einze  lnen aufgeführt sind, haben Sie das Recht, die Sie betreffenden personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten bzw. die Übermittlung dieser Daten an einen Dritten zu verlangen.",
      article7:
        "Sofern die Verarbeitung von Daten auf Grundlage Ihrer Einwilligung erfolgt, sind Sie nach Art. 7 Abs. 3 DSGVO berechtigt, die Einwilligung in die Verwendung Ihrer personenbezogenen Daten jederzeit zu widerrufen. Bitte beachten Sie, dass der Widerruf erst für die Zukunft wirkt. Verarbeitungen, die vor dem Widerruf erfolgt sind, sind davon nicht betroffen.",
      article21:
        "Werden Daten auf Grundlage von Art. 6 Abs. 1 S. 1 lit. f DSGVO (Datenverarbeitung zur Wahrung berechtigter Interessen) oder auf Grundlage von Art. 6 Abs. 1 S. 1 lit. e DSGVO (Datenverarbeitung zur Wahrung öffentlichen Interesse oder in Ausübung öffentlicher Gewalt) erhoben, steht Ihnen das Recht zu, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Widerspruch einzulegen. Wir verarbeiten die personenbezogenen Daten dann nicht mehr, es sei denn, es liegen nachweisbar zwingende schutzwürdige Gründe für die Verarbeitung vor, die gegenüber Ihren Interessen, Rechten und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.",
      article77:
        "Sie haben gem. Art. 77 DSGVO das Recht auf Beschwerde bei einer Aufsichtsbehörde, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden Daten gegen datenschutzrechtliche Bestimmungen verstößt. Das Beschwerderecht kann insbesondere bei einer Aufsichtsbehörde in dem Mitgliedstaat Ihres gewöhnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes geltend gemacht werden.",
      enforcement:
        "Sofern vorstehend nichts anderes beschrieben wurde, wenden Sie sich zur Geltendmachung Ihrer Betroffenenrechte bitte an die im Impressum genannte Stelle.",
    },
  },
  error: {
    login: {
      wrong_credentials: "E-Mail und Passwort stimmen nicht überein.",
      no_active_contracts:
        "Für ihre Gruppe besteht keine Vereinbarung mit der GRS. Bitte kontaktieren Sie den GRS-Support unter portal@grs-batterien.de.",
      too_many_requests: "Zu viele falsche Anmeldeversuche. Versuchen Sie es in 10 Minuten erneut.",
    },
  },
  pom: {
    agency: {
      groups: "Herstellerverzeichnis",
    },
    contract: {
      period: {
        monthly: "Monatlich",
        yearly: "Jährlich",
      },
    },
    reportings: {
      page_title: "Meldungen",
      period_picker: {
        empty: "Keine Meldeperioden verfügbar.",
      },
      status: {
        Open: "Offen",
        Reported: "Gemeldet",
        Corrected: "Korrigiert",
        draft: "Entwurf",
      },
      table: {
        position_no: "Pos.",
        item_no: "Art-Nr.",
        description: "Bezeichnung",
        weight_class: "Gewichtsklasse",
        unit_of_measure: "Einheit",
        current_quantity: "Aktuelle Menge",
        quantity: "Menge",
        history: "Verlauf",
        empty: "Keine Positionen für diese Meldeperiode vorhanden.",
        load_error: "Positionen konnten nicht geladen werden.",
        unit_price: "Einzelpreis",
        line_total: "Summe",
        total_net: "Gesamt (voraussichtlich, netto)",
        total_change: "davon Änderung",
        unpriced_note: "{{count}} Position(en) ohne Preis, nicht im Gesamtbetrag enthalten.",
        vat_note: "Voraussichtliche Beträge zzgl. gesetzlicher MwSt. Maßgeblich ist die Rechnung.",
      },
      header: {
        submit: "Meldung einreichen",
        change_period: "Meldeperiode ändern",
      },
      actions: {
        saveDraft: "Entwurf speichern",
        discardDraft: "Entwurf verwerfen",
        importExcel: "Excel importieren",
        exportExcel: "Excel exportieren",
      },
      draft: {
        savedSuccessfully: "Entwurf gespeichert",
        saveFailed: "Entwurf konnte nicht gespeichert werden",
        discarded: "Entwurf verworfen",
        discardFailed: "Entwurf konnte nicht verworfen werden",
        discardConfirmTitle: "Entwurf verwerfen",
        discardConfirmMessage:
          "Möchten Sie den gespeicherten Entwurf wirklich verwerfen? Diese Aktion kann nicht rückgängig gemacht werden.",
      },
      submit_dialog: {
        title: "Meldung einreichen",
        confirm_text: "Folgende Positionen werden für <strong>{{period}}</strong> gemeldet:",
        ok: "Ja, einreichen",
        cancel: "Abbrechen",
        position_no: "Pos.",
        description: "Bezeichnung",
        unit_of_measure: "Einheit",
        quantity: "Menge",
        unit_price: "Einzelpreis",
        line_total: "Summe",
        total_net: "Gesamt (voraussichtlich, netto)",
        total_change: "davon Änderung",
        unpriced_note: "{{count}} Position(en) ohne Preis, nicht im Gesamtbetrag enthalten.",
        vat_note: "Voraussichtliche Beträge zzgl. gesetzlicher MwSt. Maßgeblich ist die Rechnung.",
      },
      submit: {
        success: "Meldung wurde erfolgreich eingereicht.",
        error: "Meldung konnte nicht eingereicht werden.",
        error_with_message: "Meldung konnte nicht eingereicht werden: {{message}}",
      },
      no_contract: "Kein Vertrag ausgewählt. Bitte wählen Sie einen Vertrag auf der Startseite.",
      import_dialog: {
        title: "Excel-Vorlage importieren",
        instruction:
          "Laden Sie zunächst die Vorlage für diesen Meldezeitraum herunter, tragen Sie die Mengen ein und laden Sie die ausgefüllte Datei anschließend hoch.",
        download_template: "Vorlage herunterladen",
        select_file: "Datei hochladen",
        select_different_file: "Andere Datei hochladen",
        upload_error: "Die Datei konnte nicht verarbeitet werden. Bitte prüfen Sie, ob es sich um eine gültige Meldebogen-Vorlage handelt.",
        positions_found: "{{count}} Position(en) erfolgreich extrahiert.",
        invalid_rows_hint:
          "{{count}} Zeile(n) konnten nicht importiert werden, da der eingetragene Wert keine gültige Zahl ist. Diese Zeilen werden übersprungen:",
        invalid_row_item: "Pos. {{positionNo}}: \"{{rawValue}}\"",
        correction_hint:
          "Dieser Meldezeitraum wurde bereits eingereicht. Die importierten Mengen werden als Korrekturmeldung übernommen.",
        apply: "Übernehmen",
        cancel: "Abbrechen",
      },
      export_dialog: {
        title: "Meldedaten exportieren",
        instruction: "Wählen Sie den Zeitraum für den Excel-Export.",
        start_period: "Start-Meldeperiode",
        end_period: "End-Meldeperiode",
        export_button: "Exportieren",
        cancel: "Abbrechen",
        downloading: "Export wird erstellt...",
        success: "Export erfolgreich heruntergeladen.",
        error: "Export konnte nicht erstellt werden.",
        validation_end_before_start: "Die End-Periode muss gleich oder nach der Start-Periode liegen.",
      },
      contract_selection: {
        title: "Vertrag auswählen",
      },
      contract_switch: {
        unsaved_warning:
          "Es gibt nicht gespeicherte Änderungen. Wenn Sie den Vertrag wechseln, gehen diese verloren. Möchten Sie fortfahren?",
      },
      period_switch: {
        unsaved_warning:
          "Es gibt nicht gespeicherte Änderungen. Wenn Sie die Meldeperiode wechseln, gehen diese verloren. Möchten Sie fortfahren?",
      },
      history: {
        initial_reporting: "Erstmeldung",
        correction: "Korrektur",
        reported_by: "von {{user}}",
        unknown_reporter: "Unbekannt",
        no_entries: "Keine Einträge vorhanden.",
        load_error: "Verlauf konnte nicht geladen werden.",
        loading: "Verlauf wird geladen…",
        toggle_button_label: "Verlauf anzeigen/ausblenden",
      },
    },
  },
};
